import debounce from 'lodash-es/debounce';
import cloneDeep from 'lodash-es/cloneDeep';
import vue from './vue';
import $ from 'jquery';

async function component(el) {
  const id = el.id;
  const Vue = await vue();
  const term_data = window.term_data;

  new Vue({
    el : '#' + id,
    data : {
        alphabet_terms : {},
        reverse_terms : {},
        terms_newest : {},

        alphabets : [],

        filtered_terms : {},
        search_text : '',
        term_count : 0,
        order_by : 1,
        loading : false,
        initialized : false,
        orderChanged : false,
    },
    watch : {
        search_text : function () {
            this.orderChanged = false;
            this.beforeLoading();
            this.filterTermsDebounce();
        },
        order_by : function () {
            this.orderChanged = true;
            this.beforeLoading();
            this.filterTerms();
        },
    },
    methods : {
        beforeLoading : function () {
            this.loading = true;
            this.term_count = "...";
        },
        filterTerms : function () {
            var search_text = this.search_text;
            var order_by = this.order_by;

            this.term_count = 0;
            this.loading = true;

            var term_item_search_text_filter = function (term_item) {
                return term_item.post_title.toLowerCase().match(search_text.toLowerCase());
            };

            this.filtered_terms = {};

            if(order_by === 3) {
                this.filtered_terms[0] = this.terms_newest.filter(term_item_search_text_filter);

                this.term_count = this.filtered_terms[0].length;
            } else {
                if (order_by === 1) {
                    this.filtered_terms = cloneDeep(this.alphabet_terms);
                } else if (order_by === 2) {
                    this.filtered_terms = cloneDeep(this.reverse_terms);
                }

                for (var i = 0; i < this.alphabets.length; i++) {
                    var a = this.alphabets[i];

                    if (this.search_text.length > 0) {
                        this.filtered_terms[a] = this.filtered_terms[a].filter(term_item_search_text_filter);

                        if (this.filtered_terms[a].length === 0) {
                            delete this.filtered_terms[a];
                        }
                    }

                    if(this.filtered_terms[a] !== undefined) {
                        this.term_count += this.filtered_terms[a].length;
                    }
                }
            }

            this.loading = false;

        },
        filterTermsDebounce : debounce(function () {
            this.filterTerms();
        }, 250),
        changeOrder : function (order) {
            this.order_by = order;
            this.clearChangeOrder(); // allow assistive tech to announce change
        },
        clearChangeOrder : debounce(function () {
            this.orderChanged = false;
        }, 250),
    },
    mounted : function () {
        var self = this;

        this.beforeLoading();

        this.alphabet_terms = [...term_data]
          .sort((a, b) => {
            return a.post_title.localeCompare(b.post_title);
          })
          .reduce((carry, term) => {
            let group = term.post_title.slice(0, 1);
            group = /[a-zA-Z]/.test(group) ? group : '#';

            if (!carry[group]) {
              carry[group] = [];
            }
            carry[group].push(term);

            return carry;
          }, {});

        this.reverse_terms = {};
        Object.keys(this.alphabet_terms)
          .reverse()
          .forEach((group) => {
            this.reverse_terms[group] = this.alphabet_terms[group];
          });

        this.terms_newest = term_data;

        for(var a in this.alphabet_terms) {
            if (Object.prototype.hasOwnProperty.call(this.alphabet_terms, a)) {
                this.alphabets.push(a);
            }
        }

        self.filterTerms();

        this.initialized = true;
    },
  });
}

export default function init() {
  $('.js-terms_list').each((_idx, el) => component(el));
}
